/* eslint-disable import/no-anonymous-default-export */
import siteConfig from "../siteConfig";

export default {
  path: "/terms",
  shortTitle: "Terms",
  title: "Store terms of use and sale",
  category: "Orders and legal",
  summary: `The rules for using this ${siteConfig.operatingRegion} storefront, placing an order and interpreting product information.`,
  updated: "26 October 2026",
  sections: [
    {
      heading: "Website use",
      body: [
        "Visitors may browse and buy for lawful personal use. Automated extraction, attempts to bypass security or stock controls, interference with checkout, impersonation and use of site content to mislead others are not permitted. A user must provide accurate contact and delivery information and have authority to use the selected hosted payment method.",
      ],
    },
    {
      heading: "Order formation",
      body: [
        `A bag entry is a saved shopping choice, not allocated inventory. Pay Now requests a hosted session from the site's PHP payment bridge. Landing on its success address proves only a browser return; it proves neither settlement nor merchant acceptance. Binding acceptance follows only after ${siteConfig.brandName} checks the charge and availability and communicates acceptance or dispatch.`,
        "Before that acceptance, an obvious catalog, stock, price or technical mistake may cause a hold or refusal. Customer care will explain the practical correction or repayment option. Any money that cannot be reconciled to a genuine accepted purchase must be investigated rather than simply retained.",
      ],
    },
    {
      heading: "Products, safety and workshop entry",
      body: [
        "Dimensions, materials, care notes and warnings on the product page form part of the description. Handmade, reactive-glazed and natural-fibre goods can show the variations identified in the Product Accuracy policy. Food packaging supplied with the batch controls for ingredients, allergens and best-before information.",
        "The workshop item records a request for one participant. Date, place, capacity, accessibility arrangements and final acceptance must be confirmed directly; the checkout listing does not invent those details.",
      ],
    },
    {
      heading: "Rights and responsibility",
      body: [
        "Compulsory protections continue despite this page. They may concern ownership, matching the stated description, merchantable quality, suitability for a purpose made known, dangerous goods and unfair commercial conduct. In parallel, shoppers should compare dimensions and purpose before purchase and follow the care and safety information supplied for each material.",
        "No governing-law or exclusive-court clause is stated because the merchant has not confirmed one. Disputes should follow the Complaints and Dispute Resolution policy while preserving each party's mandatory legal rights.",
      ],
    },
  ],
};
